<template>
    <VTooltip bottom>
        <template v-slot:activator="{on}">
            <VBtn v-on="on" color="red" icon flat small
                  @click="click"
                  :disabled="$props.disabled">
                <VIcon>delete</VIcon>
            </VBtn>
        </template>
        <span>{{ $props.title }}</span>
    </VTooltip>
</template>

<script>
    export default {
        name: "BotaoExcluir",
        methods: {
            click(event) {
                this.$emit('click', event);
            }
        },
        props: {
            disabled: Boolean,
            title: {
                type: String,
                default: 'Excluir'
            }
        }
    }
</script>

<style scoped>

</style>
